module.exports = "/_next/static/images/c3e45dcede8a6e7a00a43e25e24106f4-hero-desktop-10.jpg";